__turbopack_context__.v({
  "bottomSheet": "ProductCardRing-module__soS-dq__bottomSheet",
  "pricingInfo": "ProductCardRing-module__soS-dq__pricingInfo",
  "ringSpec": "ProductCardRing-module__soS-dq__ringSpec",
  "root": "ProductCardRing-module__soS-dq__root",
  "stepFadeIn": "ProductCardRing-module__soS-dq__stepFadeIn",
});
